import { isSkillup } from '../../../lib/config/project/project';
import { IconProps } from '../../../lib/types';

type RiasecProps = IconProps & {
  quality: string;
};

const Riasec: React.FC<RiasecProps> = ({ quality, className }) => {
  quality = quality.toLowerCase();
  if (quality == 'realistic') {
    return <Realistic className={className} />;
  }
  if (quality == 'conventional') {
    return <Conventional className={className} />;
  }
  if (quality === 'social') {
    return <Social className={className} />;
  }
  if (quality === 'investigative') {
    return <Investigative className={className} />;
  }
  if (quality === 'artistic') {
    return <Artistic className={className} />;
  }
  if (quality == 'enterprising') {
    return <Enterprising className={className} />;
  }

  return <></>;
};

const Realistic: React.FC<IconProps> = ({ className }) => {
  if (isSkillup) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        className={className}
      >
        <path d="M78.6 5c-9.5-7.4-23-6.5-31.6 2L7 47c-8.5 8.5-9.4 22-2.1 31.6l80 104c4.5 5.9 11.6 9.4 19 9.4H158l109 109c-14.7 29-10 65.4 14.3 89.6l112 112c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3l-112-112c-24.2-24.2-60.6-29-89.6-14.3L192 158v-54c0-7.5-3.5-14.5-9.4-19L78.6 5zM19.9 396.1C7.2 408.8 0 426.1 0 444.1 0 481.6 30.4 512 67.9 512c18 0 35.3-7.2 48-19.9l117.8-117.8c-7.8-20.9-9-43.6-3.6-65.1l-61.7-61.7L19.9 396.1zM512 144c0-10.5-1.1-20.7-3.2-30.5-2.4-11.2-16.1-14.1-24.2-6l-63.9 63.9c-3 3-7.1 4.7-11.3 4.7H352c-8.8 0-16-7.2-16-16v-57.5c0-4.2 1.7-8.3 4.7-11.3l63.9-63.9c8.1-8.1 5.2-21.8-6-24.2C388.7 1.1 378.5 0 368 0c-79.5 0-144 64.5-144 144v.8l85.3 85.3c36-9.1 75.8.5 104 28.7l15.7 15.7c49-23 83-72.8 83-130.5zM104 432c0 13.3-10.7 24-24 24s-24-10.7-24-24 10.7-24 24-24 24 10.7 24 24z"></path>
      </svg>
    );
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30.881"
      height="38.737"
      viewBox="0 0 30.881 38.737"
      className={className}
    >
      <path
        d="M164.753 1429.03a2.024 2.024 0 00-1.456.752 2.067 2.067 0 00.094 2.678l-.517.517a1.331 1.331 0 00-.611-.188 1.175 1.175 0 00-.846.376l-1.645 1.645a.778.778 0 00-.94.047l-1.6 1.6a.668.668 0 00-.047.94l-.564.564-.047 1.6a10.982 10.982 0 00-.846 8.175 1.071 1.071 0 00.611.752 1.184 1.184 0 00.987.094l.752-.235a1.819 1.819 0 00.517-.282 1.288 1.288 0 00.376-.846v-1.08c0-1.55 0-2.208 1.269-3.477l.893-.893 6.061 6.061a6.58 6.58 0 00-1.081 3.665 7 7 0 001.973 4.792.454.454 0 010 .658l-4.6 4.6a.7.7 0 10.987.987l4.6-4.6a1.872 1.872 0 000-2.678 5.445 5.445 0 010-7.611l2.866-2.866a1.229 1.229 0 011.738 1.738l-1.879 1.879-1.645 1.644a2.453 2.453 0 000 3.477 2.2 2.2 0 001.316.658 2.465 2.465 0 002.96 2.96 2.207 2.207 0 00.658 1.315 2.294 2.294 0 001.081.611c.893.893 1.738 1.645 2.443 2.3a2.866 2.866 0 01-3.759-.235l-.517-.517-5.821 5.962a.7.7 0 00.987.987l4.933-4.933a4.244 4.244 0 005.262-.282c.47.376.846.7.987.846l1.315 1.128 3.43-3.43a2.615 2.615 0 00.752-1.973 2.233 2.233 0 00-.987-1.738c-.047-.047-.188-.094-.235-.188a5.007 5.007 0 00-.517-6.484l-3.853-3.759a4.985 4.985 0 00-5.168-1.175 2.655 2.655 0 00-.752-1.691 2.609 2.609 0 00-3.711 0l-.611.611-5.966-6.014 1.175-1.175a1.132 1.132 0 00.329-.846.9.9 0 00-.188-.564l.517-.517a2.013 2.013 0 002.678.094 2.211 2.211 0 00.752-1.456 1.984 1.984 0 00-.611-1.55l-2.772-2.772a1.871 1.871 0 00-1.5-.658zm20.061 30.023a1.031 1.031 0 01-.329.846l-2.537 2.537-.282-.235c-.517-.423-1.879-1.6-3.571-3.242l.564-.423.141-.141a2.669 2.669 0 00.611.94 2.453 2.453 0 003.477 0l1.269-1.269c.094.094.282.188.376.282a1.6 1.6 0 01.282.705zm-5.215-11.37l3.853 3.853a3.629 3.629 0 010 5.121l-1.691 1.691a1.03 1.03 0 01-1.456-1.456l1.691-1.691a.7.7 0 10-.987-.987l-3.336 3.339a1.03 1.03 0 11-1.456-1.456l3.383-3.383a.7.7 0 00-.987-.987l-3.9 3.9a1.1 1.1 0 01-1.5-.047 1.081 1.081 0 010-1.456l3.9-3.9a.7.7 0 10-.987-.987l-3.383 3.383a1.03 1.03 0 11-1.456-1.456l3.383-3.383a3.331 3.331 0 014.934-.094zm-10.242-2.3l-1.316 1.315-5.92-5.967 1.315-1.315zm-1.269-11.933a.6.6 0 01.188.47.44.44 0 01-.235.423.643.643 0 01-.846-.047l-.094-.094a1.164 1.164 0 00-1.6 0l-.846.8a1.4 1.4 0 00-.376.846 1.138 1.138 0 00.188.611l-5.262 5.262a5.24 5.24 0 00-1.691 4.416v.846l-.47.141a9.9 9.9 0 01.846-7.047l.047-.141.047-1.41 4.275-4.275a1.334 1.334 0 00.564.188 1.131 1.131 0 00.846-.329l.846-.846a1.164 1.164 0 000-1.6l-.094-.094a.6.6 0 01-.047-.846.65.65 0 01.423-.235.6.6 0 01.47.188z"
        className="a"
        transform="translate(-155.302 -1429.03)"
      ></path>
    </svg>
  );
};

const Conventional: React.FC<IconProps> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24.833"
      height="28.381"
      viewBox="0 0 24.833 28.381"
      className={className}
    >
      <path
        d="M3.548 12.417V8.869a1.774 1.774 0 10-3.548 0v3.548a1.774 1.774 0 103.548 0zm15.914-8.869A3.546 3.546 0 0015.914 0h-7.1a3.535 3.535 0 00-3.5 3.548V14.19h14.148zm3.6 3.548a1.778 1.778 0 00-1.774 1.774v3.548a1.774 1.774 0 003.548 0V8.869A1.779 1.779 0 0023.059 7.1zm-.687 10.083a1.759 1.759 0 00-1.68-1.214H4.146a1.767 1.767 0 00-1.684 1.213l-.6 1.774A1.765 1.765 0 003.5 21.286h7.145v3.735a5.251 5.251 0 00-3.43 2.065.886.886 0 00.83 1.3h8.745a.885.885 0 00.831-1.3 5.25 5.25 0 00-3.431-2.063v-3.737h7.1a1.777 1.777 0 001.683-2.335z"
        className="a"
      ></path>
    </svg>
  );
};

const Social: React.FC<IconProps> = ({ className }) => {
  if (isSkillup) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 640 512"
        className={className}
      >
        <path d="M144 160c-44.2 0-80-35.8-80-80S99.8 0 144 0s80 35.8 80 80-35.8 80-80 80zm368 0c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80zM0 298.7C0 239.8 47.8 192 106.7 192h42.7c15.9 0 31 3.5 44.6 9.7-1.3 7.2-1.9 14.7-1.9 22.3 0 38.2 16.8 72.5 43.3 96H21.3C9.6 320 0 310.4 0 298.7zM405.3 320h-.7c26.6-23.5 43.3-57.8 43.3-96 0-7.6-.7-15-1.9-22.3 13.6-6.3 28.7-9.7 44.6-9.7h42.7c58.9 0 106.7 47.8 106.7 106.7 0 11.8-9.6 21.3-21.3 21.3H405.3zm10.7-96c0 53-43 96-96 96s-96-43-96-96 43-96 96-96 96 43 96 96zM128 485.3c0-73.6 59.7-133.3 133.3-133.3h117.4c73.6 0 133.3 59.7 133.3 133.3 0 14.7-11.9 26.7-26.7 26.7H154.7c-14.7 0-26.7-11.9-26.7-26.7z"></path>
      </svg>
    );
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23.977"
      height="23.084"
      viewBox="0 0 23.977 23.084"
      className={className}
    >
      <path
        d="M230.672 165.858a2.952 2.952 0 11-2.952-2.952 2.952 2.952 0 012.952 2.952M228.831 169.617h-2.195a3.115 3.115 0 00-3.1 2.775l-.328 2.523a.638.638 0 00.5.706 18.813 18.813 0 004.011.4q.87 0 1.665-.076l.278-2.271a4.45 4.45 0 011.589-2.9 3.114 3.114 0 00-2.422-1.161zM245.608 165.858a2.952 2.952 0 11-2.952-2.952 2.952 2.952 0 012.952 2.952M246.869 172.366a3.134 3.134 0 00-3.1-2.775h-2.195a3.11 3.11 0 00-2.447 1.186 4.346 4.346 0 011.59 2.9l.278 2.271c.53.05 1.11.076 1.665.076a20.392 20.392 0 004.011-.4.66.66 0 00.5-.706zM236.273 171.105h-2.195a3.114 3.114 0 00-3.1 2.75l-.3 2.548a.623.623 0 00.5.706 18.81 18.81 0 004.011.4 20.388 20.388 0 004.011-.4.66.66 0 00.5-.706l-.3-2.548a3.158 3.158 0 00-3.127-2.75zM238.14 167.346a2.952 2.952 0 11-2.952-2.952 2.952 2.952 0 012.952 2.952M236.122 161.316a3.665 3.665 0 003.356-.051l1.514.5a.4.4 0 00.5-.5l-.5-1.488a3.69 3.69 0 00-.656-4.289 3.615 3.615 0 00-4.213-.656 4.779 4.779 0 010 6.484z"
        className="a"
        transform="translate(-223.197 -154.429)"
      ></path>
      <path
        d="M229.411 161.771l1.514-.5a3.613 3.613 0 004.264-.631 3.64 3.64 0 00-5.147-5.147 3.612 3.612 0 00-.631 4.264l-.5 1.514a.393.393 0 00.5.5z"
        className="a"
        transform="translate(-223.197 -154.429)"
      ></path>
    </svg>
  );
};

const Investigative: React.FC<IconProps> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17.293"
      height="19.764"
      viewBox="0 0 17.293 19.764"
      className={className}
    >
      <path
        d="M14.58 13.078l1.434-3.585a.623.623 0 00-.608-.847h-2.219a4.368 4.368 0 00.4-1.853c0-.159-.032-.311-.047-.466 1.541-.34 2.517-.835 2.517-1.387 0-.621-1.226-1.169-3.1-1.505C12.5 1.743 11.769 0 10.708 0a1.739 1.739 0 00-1.057.405 1.636 1.636 0 01-2.007 0A1.727 1.727 0 006.589 0C5.528 0 4.8 1.743 4.343 3.435c-1.879.336-3.107.885-3.107 1.506 0 .554.977 1.047 2.518 1.387-.015.154-.047.308-.047.466a4.9 4.9 0 00.367 1.853h-2.22a.617.617 0 00-.574.845l1.434 3.585A6.656 6.656 0 000 18.424a1.338 1.338 0 001.338 1.339h14.616a1.338 1.338 0 001.339-1.339 6.657 6.657 0 00-2.713-5.346zm-7.786 5.416l-1.853-7.377 2.47 1.235.618 1.235zm3.671 0l-1.2-4.906.618-1.235 2.47-1.235zM12.352 7.18a1.474 1.474 0 01-1.482 1.467h-.476a1.461 1.461 0 01-1.375-.965.39.39 0 00-.743 0 1.465 1.465 0 01-1.376.965h-.474A1.475 1.475 0 014.941 7.18v-.637a25.824 25.824 0 003.706.251 25.874 25.874 0 003.706-.25z"
        className="a"
      ></path>
    </svg>
  );
};

const Artistic: React.FC<IconProps> = ({ className }) => {
  if (isSkillup) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        className={className}
      >
        <path d="M512 256v2.7c-.4 36.5-33.6 61.3-70.1 61.3H344c-26.5 0-48 21.5-48 48 0 3.4.4 6.7 1 9.9 2.1 10.2 6.5 20 10.8 29.9 6.1 13.8 12.1 27.5 12.1 42 0 31.8-21.6 60.7-53.4 62-3.5.1-7 .2-10.6.2C114.6 512 0 397.4 0 256S114.6 0 256 0s256 114.6 256 256zm-384 32c0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32 32-14.3 32-32zm0-96c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-96c0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32 32-14.3 32-32zm96 96c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"></path>
      </svg>
    );
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20.558"
      height="18.843"
      viewBox="0 0 20.558 18.843"
      className={className}
    >
      <path
        d="M145.834 159.491c-.378-.278-.61-.459-.606-.71.011-.738-.092-1.1-.356-1.26a.5.5 0 00-.514.011c-.689.392-1.528 2.743-1.528 3.667a3.176 3.176 0 00.793 2.178l-.014.01a.342.342 0 00-.093.255l.685 12.334a.343.343 0 00.342.323h.685a.343.343 0 00.343-.323l.685-12.334a.343.343 0 00-.093-.255l-.014-.01a3.175 3.175 0 00.793-2.178 2.085 2.085 0 00-1.107-1.708zm-.283 4.474l-.038.685h-1.255l-.038-.685zm-1.255 1.37h1.179l-.038.685h-1.1zm.608 10.278h-.037l-.5-8.908h1.028zm-.018-12.334c-.743 0-1.37-.953-1.37-2.081a7.214 7.214 0 011.012-2.889 3.872 3.872 0 01.016.46c-.009.617.467.965.887 1.273.443.324.826.606.826 1.155-.001 1.132-.629 2.084-1.372 2.084zM141.459 165.338a.958.958 0 01.186.014l.112.016a.343.343 0 00.377-.424 8.056 8.056 0 00-7.87-5.771 7.545 7.545 0 100 15.075 8.459 8.459 0 007.859-5.019.344.344 0 00-.345-.463h-.314c-1.373 0-2.577-.8-2.577-1.713s1.2-1.713 2.577-1.713zm-3.262 1.713c0 1.257 1.4 2.326 3.089 2.395a7.879 7.879 0 01-7.021 4.115 6.86 6.86 0 110-13.7 7.426 7.426 0 017.07 4.8c-1.713.05-3.137 1.129-3.137 2.4z"
        className="a"
        transform="translate(-126.384 -157.458)"
      ></path>
      <path
        d="M131.181 165.282a1.715 1.715 0 10-1.211-.5 1.714 1.714 0 001.211.5zm0-2.741a1.028 1.028 0 11-.727.3 1.028 1.028 0 01.727-.304zM135.978 160.824a1.715 1.715 0 101.211.5 1.714 1.714 0 00-1.211-.5zm0 2.741a1.028 1.028 0 11.727-.3 1.028 1.028 0 01-.727.3zM129.81 166.306a1.715 1.715 0 101.211.5 1.714 1.714 0 00-1.211-.5zm0 2.741a1.028 1.028 0 11.727-.3 1.028 1.028 0 01-.727.3zM133.579 169.389a1.715 1.715 0 101.211.5 1.714 1.714 0 00-1.211-.5zm0 2.741a1.028 1.028 0 11.727-.3 1.028 1.028 0 01-.727.3z"
        className="a"
        transform="translate(-126.384 -157.458)"
      ></path>
    </svg>
  );
};
const Enterprising: React.FC<IconProps> = ({ className }) => {
  if (isSkillup) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        className={className}
      >
        <path d="M184 48h144c4.4 0 8 3.6 8 8v40H176V56c0-4.4 3.6-8 8-8zm-56 8v40H64c-35.3 0-64 28.7-64 64v96h512v-96c0-35.3-28.7-64-64-64h-64V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zm384 232H320v32c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-32H0v128c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V288z"></path>
      </svg>
    );
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19.337"
      height="15.471"
      viewBox="0 0 19.337 15.471"
      className={className}
    >
      <path
        d="M7.254 13.729a1.03 1.03 0 00.162.534l.516.776a1.086 1.086 0 00.805.431H10.6a1.078 1.078 0 00.8-.431l.516-.776a1.118 1.118 0 00.162-.534V12.57H7.254zM9.653 0a5.3 5.3 0 00-3.987 8.785 8.646 8.646 0 011.578 2.764v.023h4.843v-.023a8.637 8.637 0 011.585-2.764A5.3 5.3 0 009.653 0zm.015 2.9a2.414 2.414 0 00-2.417 2.39.483.483 0 01-.967 0 3.381 3.381 0 013.384-3.357.483.483 0 110 .967zM3.384 5.8a.725.725 0 00-.725-.725H.725a.725.725 0 000 1.45h1.934a.725.725 0 00.725-.725zm15.228-.725h-1.934a.725.725 0 100 1.45h1.934a.725.725 0 000-1.45zM3.961 1.669L2.284.702A.726.726 0 001.551.69a.726.726 0 00.008 1.265l1.677.967a.726.726 0 00.733.011.736.736 0 00.366-.634.728.728 0 00-.374-.63zm13.817 7.978L16.1 8.68a.726.726 0 00-.733-.011.726.726 0 00.008 1.265l1.677.967a.724.724 0 00.725-1.254zM3.236 8.68l-1.676.967a.724.724 0 10.725 1.254l1.677-.967a.725.725 0 00-.726-1.254zm12.505-5.659a.736.736 0 00.363-.1l1.673-.967a.724.724 0 00-.725-1.252l-1.673.967a.724.724 0 00.363 1.352z"
        className="a"
      ></path>
    </svg>
  );
};
export default Riasec;
